module.exports = "pegasus/assets/blocks/column-14-theme3.png";